import { Table } from '@mantine/core';
import { PlanType } from 'api/models';
import { i18nKeys, useTranslation } from 'locales';
import { useHistory } from 'react-router-dom';
import { useLoadPaymentWorkflows } from '../api';
import { PlanNameCell } from './PlanNameCell';
import { WorkflowsTable } from './WorkflowsTable';

const EDIT_PATH = `/settings/workflows/${PlanType.payment}/edit`;

export const PaymentWorkflowsTable = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const { paymentWorkflows = [], isPaymentWorkflowsLoading } = useLoadPaymentWorkflows();

  return (
    <WorkflowsTable
      columns={[
        t(i18nKeys.NAME),
        t(i18nKeys.SETTINGS.WORKFLOWS.STEPS),
        t(i18nKeys.SETTINGS.WORKFLOWS.ACTIVE_PLANS),
        t(i18nKeys.SETTINGS.WORKFLOWS.LAST_EDITED),
      ]}
      isLoading={isPaymentWorkflowsLoading}
    >
      {paymentWorkflows.map(workflow => (
        <Table.Tr
          key={workflow.id}
          style={{ cursor: 'pointer' }}
          onClick={() => history.push(`${EDIT_PATH}/${workflow.id}`)}
        >
          <PlanNameCell name={workflow.name} isDefault={workflow.isDefault} />
          <Table.Td>{workflow.stepsCount}</Table.Td>
          <Table.Td>{workflow.activePlansCount}</Table.Td>
          <Table.Td>{workflow.updatedAt.format('L')}</Table.Td>
        </Table.Tr>
      ))}
    </WorkflowsTable>
  );
};
